export default __webpack_public_path__ + "8e5bb296e728c0ca5268bd9bd0f89c25.svg";